import { StoryblokStory } from '@storyblok/react/rsc';
import React from 'react';

interface RenderStoryblokComponentProps {
  blok: any;
  storyblokComponentName?: string;
  additionalProps?: {
    [key: string]: any;
  };
}

const RenderStoryblokComponent = ({
  blok,
  storyblokComponentName = 'Storyblok Component',
  additionalProps,
}: RenderStoryblokComponentProps) => {
  let storyblokComponentArray;

  if (blok.Page) {
    storyblokComponentArray = blok.Page.filter(
      (element: any) => element.component === storyblokComponentName
    );
  } else {
    storyblokComponentArray = blok[storyblokComponentName] ?? blok;
  }

  return (
    <>
      {storyblokComponentArray.length > 0 &&
        storyblokComponentArray.map((element: any) => {
          return (
            <StoryblokStory
              key={element._uid}
              story={{ content: element }}
              bridgeOptions={{}}
              additionalProps={{ ...additionalProps }}
            />
          );
        })}
    </>
  );
};

export default RenderStoryblokComponent;
